import { render, staticRenderFns } from "./TableLivreurs.vue?vue&type=template&id=4add5b45&"
import script from "./TableLivreurs.vue?vue&type=script&lang=js&"
export * from "./TableLivreurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports